module.exports = {
      id: "my-vikatan-logo-usage",
      viewBox: "0 0 500 200",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#my-vikatan-logo",
      toString: function () {
        return this.url;
      }
    }